import { CollectResponseData } from "@lib/titan2-slingo/dist/api/data/CollectResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
/**
 * ExtendedCollectResponseData.ts
 */
export class ExtendedCollectResponseData extends CollectResponseData {
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
}
//# sourceMappingURL=ExtendedCollectResponseData.js.map